import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import healthExLogo from "../Media/mobile-healthex-logo.png";
import { HXMobileHealthExLogo } from "./HXMobileLogos.styles";
import { HeaderContainer, NavigationLeftButtonsStack, NavigationRightButtonsStack, PaddingButton, Title, } from "./HXMobileTitleHeader.styles";
import { withLoadTracking } from "./withLoadTracking";
const HealthExLogoWithLoadTracking = withLoadTracking(HXMobileHealthExLogo);
export const TitleHeaderView = observer((props) => {
    var _a, _b;
    const padButtonsForCenteringTitle = props.padButtonsForCenteringTitle === true;
    const leftButtons = (_a = props.leftIconButtons) !== null && _a !== void 0 ? _a : [];
    const rightButtons = (_b = props.rightIconButtons) !== null && _b !== void 0 ? _b : [];
    const leftPaddingButtons = padButtonsForCenteringTitle && rightButtons.length >= leftButtons.length
        ? Array(rightButtons.length - leftButtons.length)
            .fill(null)
            .map((_, i) => _jsx(PaddingButton, {}, `right-padding-button-${i}`))
        : [];
    const rightPaddingButtons = padButtonsForCenteringTitle && leftButtons.length >= rightButtons.length
        ? Array(leftButtons.length - rightButtons.length)
            .fill(null)
            .map((_, i) => _jsx(PaddingButton, {}, `left-padding-button-${i}`))
        : [];
    return (_jsxs(HeaderContainer, { showBottomBorder: props.showBottomBorder, padding: props.padding, children: [_jsxs(NavigationLeftButtonsStack, { width: props.buttonsContainerWidth, children: [leftButtons.map((button) => button), leftPaddingButtons.map((button) => button)] }), props.title && _jsx(Title, { children: props.title }), !props.title && props.showLogo && (_jsx(HealthExLogoWithLoadTracking, { src: healthExLogo, isScreenshotMode: props.isScreenshotMode })), _jsxs(NavigationRightButtonsStack, { width: props.buttonsContainerWidth, children: [rightPaddingButtons.map((button) => button), rightButtons.map((button) => button)] })] }));
});
